import { render } from "./mapMelk.vue?vue&type=template&id=1173997d&scoped=true"
import script from "./mapMelk.vue?vue&type=script&lang=js"
export * from "./mapMelk.vue?vue&type=script&lang=js"

import "./mapMelk.vue?vue&type=style&index=0&id=1173997d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1173997d"]])

export default __exports__